// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__100H0","label":"Radio_label__3i3r-","checkMark":"Radio_checkMark__2tynk","disabled":"Radio_disabled__1xznh"};